<div class="schedule-form-item clearfix">
  <div class="clearfix">
    <div class="schedule-col schedule-col-30 pad-right">
      <label class="modal-label" for="start-time">Starting at</label>
    </div>
    <div class="schedule-col schedule-col-70"></div>
  </div>
  <div class="schedule-col schedule-col-30 pad-right">
    <mat-select
      id="schedule-interval-selector"
      (selectionChange)="startTimeChanged.emit($event.value)"
      [(value)]="startTimeSelected"
      data-test="start-time-selector"
    >
      <mat-option
        class="minute-option"
        *ngFor="let option of options[frequencyType]"
        [value]="option.value"
        [attr.data-test]="option.displayName"
        >{{ option.displayName }}</mat-option
      >
    </mat-select>
  </div>
  <div class="schedule-col schedule-col-70">
    <label class="schedule-label-inline">minutes past the hour</label>
  </div>
</div>
